/**
 * Local-only demo switch.
 *
 * It is intentionally gated by both Vite's development flag and an explicit
 * env value. Production builds can never activate this mode.
 */
export function isDemoEnvEnabled(env: {
  DEV?: boolean;
  VITE_DEMO_MODE?: string;
} | undefined): boolean {
  if (!env) return false;
  return env.DEV === true && env.VITE_DEMO_MODE === "1";
}

export const isDemoMode = isDemoEnvEnabled(import.meta.env);

const DEMO_SESSION_KEY = "wenlix-demo-session-v1";

export interface DemoUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: "owner";
  status: "active";
  approval_status: "approved";
  is_blocked: false;
  auth_source: "legacy";
  account_type: "wenlix_internal_manager";
  business_role: "owner";
  business_api: "core";
  permissions: string[];
}

export const demoUser: DemoUser = {
  id: "demo-owner",
  email: "demo.owner@local.test",
  first_name: "Демо",
  last_name: "Владелец",
  full_name: "Демо Владелец",
  role: "owner",
  status: "active",
  approval_status: "approved",
  is_blocked: false,
  auth_source: "legacy",
  account_type: "wenlix_internal_manager",
  business_role: "owner",
  business_api: "core",
  permissions: ["demo"],
};

function canUseBrowserStorage(): boolean {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function startDemoSession(): boolean {
  if (!isDemoMode || !canUseBrowserStorage()) return false;

  window.sessionStorage.setItem(DEMO_SESSION_KEY, "active");
  return true;
}

export function clearDemoSession(): void {
  if (!canUseBrowserStorage()) return;
  window.sessionStorage.removeItem(DEMO_SESSION_KEY);
}

export function isDemoSession(): boolean {
  return isDemoMode && canUseBrowserStorage() &&
    window.sessionStorage.getItem(DEMO_SESSION_KEY) === "active";
}

export function getDemoUser(): DemoUser | null {
  return isDemoSession() ? demoUser : null;
}
